export default __webpack_public_path__ + "static/conversion-over-time-using-trends-dark-mode-fbe56b61dc837eefc118a3436f7ad135.png";